var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.114,
    height: 24,
    viewBox: "0 0 24.114 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389",
    transform: "translate(-6321.593 -3372.708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2368",
    "data-name": "Rectangle 2368",
    width: 22,
    height: 22,
    transform: "translate(6321.593 3374.593)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M6803.387-8803.407a1.745,1.745,0,0,1-1.741-1.744v-4.477a1.742,1.742,0,0,1,1.741-1.741h7.463a1.741,1.741,0,0,1,1.741,1.741v4.477a1.744,1.744,0,0,1-1.741,1.744Zm-.248-6.221v4.477a.25.25,0,0,0,.248.251h7.463a.252.252,0,0,0,.25-.251v-4.477a.249.249,0,0,0-.25-.248h-7.463A.247.247,0,0,0,6803.139-8809.628Zm-12.805,6.221a1.745,1.745,0,0,1-1.741-1.741v-10.45a1.743,1.743,0,0,1,1.741-1.741h7.466a1.742,1.742,0,0,1,1.741,1.741v10.45a1.744,1.744,0,0,1-1.741,1.741Zm-.248-12.191v10.45a.249.249,0,0,0,.248.248h7.466a.251.251,0,0,0,.248-.248v-10.45a.249.249,0,0,0-.248-.248h-7.466A.247.247,0,0,0,6790.086-8815.6Zm13.3,2.124a1.742,1.742,0,0,1-1.741-1.741v-10.449a1.745,1.745,0,0,1,1.741-1.742h7.463a1.743,1.743,0,0,1,1.741,1.742v10.449a1.741,1.741,0,0,1-1.741,1.741Zm-.248-12.19v10.449a.247.247,0,0,0,.248.248h7.463a.249.249,0,0,0,.25-.248v-10.449a.25.25,0,0,0-.25-.249h-7.463A.248.248,0,0,0,6803.139-8825.665Zm-12.805,6.221a1.743,1.743,0,0,1-1.741-1.741v-4.479a1.745,1.745,0,0,1,1.741-1.742h7.466a1.745,1.745,0,0,1,1.741,1.742v4.479a1.743,1.743,0,0,1-1.741,1.741Zm-.248-6.221v4.479a.248.248,0,0,0,.248.248h7.466a.249.249,0,0,0,.248-.248v-4.479a.25.25,0,0,0-.248-.249h-7.466A.248.248,0,0,0,6790.086-8825.665Z",
    transform: "translate(-466.884 12200.115)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.98cc236d.svg";
export { ForwardRef as ReactComponent };